// extracted by mini-css-extract-plugin
export default {"container":"modal_container__SmpB6","backdrop":"modal_backdrop__0Bn65","modal":"modal_modal__nSuwB","header":"modal_header__SBslo","title":"modal_title__GtnE+"};